/* tslint:disable */
/* This file should be ignored by git and the .svg file checked in instead.
 * This file was generated with 'svg-gen'. Manual changes will be lost. */
import React from 'react';
import { createIcon } from '../../createIcon';
export var GroupIcon = createIcon("GroupIcon", function (title) {
  var _color = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return /*#__PURE__*/React.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, /*#__PURE__*/React.createElement("title", null, title), /*#__PURE__*/React.createElement("path", {
    d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.25 10.125a1.125 1.125 0 100-2.25 1.125 1.125 0 000 2.25Zm0 .75c-1.036 0-1.875.84-1.875 1.875v1.125h.75l.375 3H9m6.75-6.75a1.125 1.125 0 100-2.25 1.125 1.125 0 000 2.25Zm0 .75c1.035 0 1.875.84 1.875 1.875v1.125h-.75l-.375 3H15m-3-7.5a1.5 1.5 0 100-3 1.5 1.5 0 000 3Z",
    stroke: "#171717",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M14.625 12.75a2.625 2.625 0 00-5.25 0v1.125H10.5l.375 3.75h2.25l.375-3.75h1.125V12.75Z",
    stroke: "#171717",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}, {});